import React, { useEffect, useRef, useState } from "react";
import MainConteiner from "../components/partials/maincontainer";
import PrimaryBtn, { IconButton } from "../components/partials/btn";
import { Icon } from "@iconify/react";
import { FaChevronDown } from "react-icons/fa6";
import SelectFilterModal from "../components/modals/selectfilter";
// import SystemArchitecture from "../components/SystemArchitecture";
import DetailsModal from "../components/modals/detailsmodal";
import Effectiveness from "../assets/icons/effective.svg";
import Moderate from "../assets/icons/moderate.svg";
import Ineffective from "../assets/icons/ineffective.svg";
import Digital from "../assets/icons/digital.svg";
import SystemTestArchitecture from "../components/SystemTestArchitecture";
import {
  effectivenessList,
  informationCollectionToolList,
} from "../utils/types";
import {
  effectivenessToHex,
  typeToHex,
} from "../components/reactflowchart/FlowCanvas";
import { useRequestStore } from "../data/stores/loggerStore";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { TriggerModal } from "../components/modals/successmodal";

const Dashboard = () => {
  const [modal, setModal] = useState("");
  const [start, setStart] = useState<any>(false);
  const [effectiveness, setEffectiveness] = useState(false);
  const [systemType, setSystemType] = useState(false);
  const systemTypeRef = useRef(null),
    { countrySystemOwner }: any = useRequestStore();

  useEffect(() => {
    if (systemType && systemTypeRef.current) {
      systemTypeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [systemType]);
  const Arr2 = [
    {
      icon: Effectiveness,
      title: "Paper Based Tools",
      desc: "fully capable and well suited to its role",
    },
    {
      icon: Digital,
      title: "Digital Tools",
      desc: "partially capable and suited to its role with some challenges/barriers",
    },
  ];
  const Arr = [
    {
      icon: Effectiveness,
      title: "Effective",
      desc: "fully capable and well suited to its role",
    },
    {
      icon: Moderate,
      title: "Moderately Effective",
      desc: "partially capable and suited to its role with some challenges/barriers",
    },
    {
      icon: Ineffective,
      title: "Ineffective",
      desc: "not capable or suited to its role with significant challenges/barriers",
    },
  ];

  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `${
      countrySystemOwner?.docs?.find(
        (ic: any) => ic?._id === start?.organization
      )?.user?.organizationName || "Choose Organisation"
    }-${moment().format("DD/MM/YYYY")}`,
    bodyClass: "px-5",
  });

  return (
    <div>
      <MainConteiner>
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-4xl text-sec font-medium">Dashboard</h3>
            <p className="text-base font-normal text-[#667085]">
              Your current data assessment
            </p>
          </div>
          <div className="flex gap-5 items-center">
            <IconButton
              icon="humbleicons:download"
              text="Export"
              onClick={() => {
                if (start) {
                  setModal("export");
                  // handlePrint();
                }
              }}
            />
            {/* <IconButton
              icon="material-symbols:add"
              color="white"
              text="Invite"
              bg="#2070B8"
            /> */}
          </div>
        </div>
        <div ref={componentRef}>
          <div className="mt-12 w-full flex gap-6 page-break">
            <div
              onClick={() => setModal("organization")}
              className="h-10 main-border cursor-pointer main-shador bg-white rounded-lg px-4 w-80 flex justify-between items-center"
            >
              <div className="flex items-center gap-3">
                <Icon
                  icon={"mynaui:user"}
                  style={{
                    fontSize: "24px",
                  }}
                  color="#667085"
                />
                <span className="text-base font-normal text-sec">
                  {start
                    ? countrySystemOwner?.docs?.find(
                        (ic: any) => ic?._id === start?.organization
                      )?.user?.organizationName || `Choose Organisation`
                    : `Choose Organisation`}
                </span>
              </div>
              <FaChevronDown />
            </div>
            <IconButton
              active={effectiveness}
              disabled={start === false}
              icon="lets-icons:view-light"
              onClick={() => {
                setSystemType(false);
                setEffectiveness(!effectiveness);
              }}
              text="View Effectiveness"
            />
            <IconButton
              disabled={start === false}
              icon="lets-icons:view-light"
              active={systemType}
              onClick={() => {
                setEffectiveness(false);
                setSystemType(!systemType);
              }}
              text="View System Type"
            />
          </div>
          {effectiveness && (
            <div className="transition-all duration-300 transform translate-y-0 opacity-100 mt-4 page-break">
              <div className="flex gap-1 items-center page-break">
                <Icon
                  icon="lets-icons:view-light"
                  className="font-bold text-xl"
                  color="#344054"
                />
                <h5 className="text-sm underline font-medium text-[#344054]">
                  Effectiveness
                </h5>
              </div>
              <div className="mt-3 space-y-2 page-break">
                {effectivenessList?.map((it) => (
                  <div key={it} className="flex gap-4 items-center page-break">
                    {/* <img src={it?.icon} alt="" /> */}
                    <div
                      className={`px-5 py-2`}
                      style={{
                        borderColor: effectivenessToHex(it),
                        borderWidth: "3px",
                        borderStyle: "dashed",
                      }}
                    />
                    <p className="text-sm font-normal text-[#344054]">
                      <span className="font-bold">{it}: </span>
                      {Arr?.find((ic) => ic?.title === it)?.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {start ? (
            <div className=" page-break">
              <div className="w-full ">
                <SystemTestArchitecture
                  onClick={(d?: string) => setModal(d)}
                  usecase={
                    effectiveness ? "effectiveness" : systemType ? "type" : null
                  }
                  orgData={start?.organization}
                />
                {/* {process.env.REACT_APP_NODE_INTEGRATION ? (
								<></>
							) : (
								<SystemArchitecture onClick={() => setModal("details")} />
							)} */}
              </div>
            </div>
          ) : (
            <div className="mt-16 flex w-full justify-center">
              <div>
                <div
                  style={{
                    border: "8px solid #E6F3FE",
                  }}
                  className="size-12 rounded-full mx-auto flex justify-center items-center bg-[#E6F3FE]"
                >
                  <Icon
                    icon={"mynaui:search"}
                    color="#2070B8"
                    style={{
                      fontSize: "24px",
                    }}
                  />
                </div>
                <h4 className="text-xl mt-1 font-medium text-sec text-center">
                  No organisation selected
                </h4>
                <p className="text-sm font-normal mt-1 text-es-gray-100 text-center mx-auto max-w-sm">
                  Kindly select an organisation by the top left to get started
                </p>
                <div className="mt-4 flex justify-center">
                  <PrimaryBtn
                    text="Select Organisation"
                    onClick={() => setModal("organization")}
                  />
                </div>
              </div>
            </div>
          )}
          <div
            ref={systemTypeRef}
            className={`transition-all duration-300 transform ${
              systemType
                ? "translate-y-0 opacity-100"
                : "-translate-y-10 opacity-0"
            } mt-4 page-break`}
          >
            <div className="flex gap-1 items-center">
              <Icon
                icon="lets-icons:view-light"
                className="font-bold text-xl"
                color="#344054"
              />
              <h5 className="text-sm underline font-medium text-[#344054]">
                System Type
              </h5>
            </div>
            <div className="mt-3 space-y-2 page-break">
              {informationCollectionToolList?.map((it) => (
                <div className="flex gap-4 items-center page-break">
                  <div
                    className={`px-5 py-2 border-3 border-dashed`}
                    style={{
                      borderColor: typeToHex(it),
                      borderWidth: "3px",
                      borderStyle: "dashed",
                    }}
                  />
                  <p className="text-sm font-normal text-[#344054]">
                    <span className="font-bold">{it}: </span>
                    {Arr2?.find((ic) => ic?.title === it)?.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </MainConteiner>
      {modal === "organization" ? (
        <SelectFilterModal
          onClick={(d?: any) => {
            if (d?.organization) {
              setStart(d);
              setModal("");
            }
          }}
          handleClose={() => setModal("")}
        />
      ) : modal === "export" ? (
        <TriggerModal
          page="/dashboard"
          title="Export Report"
          desc={`To export, kindly select the landscape layout and a paper size of A3 and above under 'more settings`}
          onClick={() => {
            handlePrint();
            setModal("");
          }}
          onClose={() => {
            setModal("");
          }}
          btnText="Export"
        />
      ) : modal ? (
        <DetailsModal handleClose={() => setModal("")} detail={modal} />
      ) : null}
    </div>
  );
};

export default Dashboard;
